export enum PatterType {
    CLIP_PATH = 'clipPath'
}
